import React from 'react';
import styled from 'styled-components/macro';
import { msTransition } from 'helpers/msTransition';

interface IShared {
  label: string;
}

interface IButton extends IShared {
  tag: 'button';
  onClick: (e: React.MouseEvent) => void;
}

interface ILink extends IShared {
  tag: 'a';
  href: string;
  target?: string;
}

type IProps = IButton | ILink;

export const StyledButton = styled.button`
  padding: ${({ theme }) => ` ${theme.spacing['1.5']} ${theme.spacing[3]}`};
  border-radius: ${({ theme }) => theme.radius.full};
  background: ${({ theme }) => theme.colors.green};
  border: none;
  font-size: ${({ theme }) => theme.typography[-1]};
  font-weight: 500;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.black};
  text-decoration: none;
  align-self: center;
  cursor: pointer;
  transition: background-color ${({ theme }) => msTransition(theme.transition.normal)};

  &:hover {
    background: ${({ theme }) => theme.colors.black};
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const Button: React.FC<IProps> = (props) => {
  const{ tag } = props;

  switch (props.tag) {
    case 'a':
      return <StyledButton as={props.tag} href={props.href} target={props.target ?? '_blank'}>{props.label}</StyledButton>;
    case 'button':
      return <StyledButton as={props.tag} onClick={props.onClick}>{props.label}</StyledButton>;
    default:
      throw new Error(`You've passed in ${tag} which is not a valid button tag`);
  }
};